module.exports = __webpack_public_path__ + "static/media/concept-energy-label-b.2c4ffe2a.svg";